// eslint-disable-next-line import/prefer-default-export
export const SET_DATA_SURVEY = "[SURVEY_TYPES] SET_DATA_SURVEY";
